import { render, staticRenderFns } from "./CrmRelativeAllTable.vue?vue&type=template&id=3b1b19c8&scoped=true&"
import script from "./CrmRelativeAllTable.vue?vue&type=script&lang=js&"
export * from "./CrmRelativeAllTable.vue?vue&type=script&lang=js&"
import style0 from "./CrmRelativeAllTable.vue?vue&type=style&index=0&id=3b1b19c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1b19c8",
  null
  
)

export default component.exports